/**
 * Detects an axios timeout (per-request `timeout` option exceeded). Distinct
 * from a generic network failure: the request was issued and the server simply
 * didn't respond in time, which is the case worth retrying.
 *
 * Pinned to the axios 1.x error shape: `error.name === 'AxiosError'` and
 * `error.code === 'ECONNABORTED'` (or `'ETIMEDOUT'` when `clarifyTimeoutError`
 * is enabled). AbortController-cancelled requests surface as `'CanceledError'`
 * with `code === 'ERR_CANCELED'` and are intentionally excluded.
 *
 * Kept as a duck-typed check so callers don't need an axios dependency. If
 * axios changes its error class name in a future major, this guard will
 * silently start returning false — revisit on axios upgrade.
 */
export function isAxiosTimeout(error) {
    if (!(error instanceof Error))
        return false;
    if (error.name !== 'AxiosError')
        return false;
    const code = error.code;
    return code === 'ECONNABORTED' || code === 'ETIMEDOUT';
}
